<template>
    <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-title>
                <span class="text-h5">Nuevo instalador</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-form ref="formPersonal" lazy-validation>
                        <v-row style="margin-top:.5rem ;">
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Nombre*" v-model="pacienteData.nombre" required outlined dense
                                    :rules="[campoRequerido]"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-text-field label="Descripción*" v-model="pacienteData.descripcion" required outlined
                                    dense :rules="[campoRequerido]"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6" md="6">
                                <v-file-input v-model="pacienteData.imagen" label="Subir imagen"
                                    :rules="[campoRequerido]" outlined dense show-size></v-file-input>
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                                <v-file-input v-model="pacienteData.url" label="Subir archivo" :rules="[campoRequerido]"
                                    outlined dense show-size></v-file-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="editClose">
                    Cancelar
                </v-btn>
                <v-btn color="blue darken-1" text @click="createItem">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-form>
        <v-dialog v-model="dialogLoader" hide-overlay persistent width="300" class="fondo-griss">
            <v-card color="primary" dark>
                <v-card-text>
                    Cargando Datos
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<style>
.bg-primary-table {
    font-weight: 400;
}

.text-start {
    font-size: 0.8rem !important;
}

.container {
    max-width: 3000px !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
    padding-top: 0px;
    margin-bottom: 0px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
    props: ['idItem'],
    data() {
        return {
            dialogLoader: false,
            pacienteData: {
                nombre: null,
                descripcion: null,
                imagen: null,
                url: null,
                fecha_modificacion: new Date()
                    .toISOString()
                    .substr(0, 10),
            },
            datosSoporte: {
                imagen: null,
                url: null,
            },
            cas: null,
            maestro: null,
            deleteUser: [],
            statusEdit: false,
            date: new Date(
                Date.now() - 2592000000 - new Date().getTimezoneOffset() * 60000
            )
                .toISOString()
                .substr(0, 10),
            dialogEdit: false,
            dialogDelete: false,
            dataCas: [],
            dataMaesto: [],
            isLoading: false,
            itemsTipSex: [{ value: "M", label: "MASCULINO" }, { value: "F", label: "FEMENINO" }],
            menu: false,
            e1: 1,
            step: 1,
            menu1: false,
            date1: new Date()
                .toISOString()
                .substr(0, 10),
            arraySerologia: [{ value: "POSITIVO", label: "Positivo" }, { value: "NEGATIVO", label: "Negativo" }],
            dataHospital: [],
            dataMedico: [],
            campoRequerido: (v) => !!v || "Campo Obligatorio.",
        };
    },
    methods: {
        closeDialogAsignarCupo() {
            this.dialogAsignarCupo = false;
        },
        filtro() {
            this.dataEnvio.fecha = this.date;
            this.dataEnvio.fecha = this.formatearFecha(this.date);

        },
        createOpen() {
            this.clearForm();
            this.titleButton = "Aceptar";
            this.titleCard = "Crear Usuario";
            this.dialogEdit = true;
        },
        editClose() {
            this.$emit("editClose");
        },
        deleteOpen(item) {
            this.deleteUser = item;
            this.dialogDelete = true;
        },
        deleteClose() {
            this.dialogDelete = false;
        },
        createItem() {
            this.dialogLoader = true;
            let InstFormData = new FormData();
            InstFormData.append('nombre', this.pacienteData.nombre);
            InstFormData.append('descripcion', this.pacienteData.descripcion);
            InstFormData.append('fecha_modificacion', new Date(Date.now())
                .toISOString()
                .substr(0, 10));
            InstFormData.append('archivo', this.pacienteData.url);
            InstFormData.append('imagen', this.pacienteData.imagen);
            if (!this.$refs.form.validate()) {
                Swal.fire({
                    title: "¡Error!",
                    text: "¡Debe completar los campos obligatorios!",
                    icon: "error",
                });
                return;
            }
            axios
                .post("http://10.0.52.64:8000/api/token/", {
                    "username": 'cnsr',
                    "password": '123456',
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post("http://10.0.52.64:8000/instaladores/", InstFormData, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Éxito!",
                                text: "¡Se registró correctamente!",
                                icon: "success",
                                showCancelButton: true,
                            })
                            this.editClose();
                            this.clearForm();
                            this.dialogEdit = false;
                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        editItem() {
            this.dialogLoader = true;
            if (!this.$refs.form.validate()) {
                Swal.fire({
                    title: "¡Error!",
                    text: "¡Debe completar los campos obligatorios!",
                    icon: "error",
                });
                return;
            }
            this.pacienteData.longitud = this.pacienteData.cordePacForm.split(",")[1];
            this.pacienteData.latitud = this.pacienteData.cordePacForm.split(",")[0];
            this.pacienteData.fecha_nac = this.date;
            this.pacienteData.ubigeo_id = this.pacienteData.distrito;
            this.pacienteData.cordePac =
                "SRID=4326;POINT (" +
                this.pacienteData.cordePacForm.split(",")[1].trim() +
                " " +
                this.pacienteData.cordePacForm.split(",")[0].trim() +
                ")";
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .patch(
                            RUTA_API + "/paciente/" + this.pacienteData.url.split("/")[4] + "/",
                            this.pacienteData,
                            {
                                headers: { Authorization: this.auth },
                            }
                        )
                        .then((res) => {
                            this.dialogLoader = false;
                            this.editClose();
                            this.clearForm();
                            this.statusEdit = false;
                            this.dialogEdit = false;
                            Swal.fire({
                                title: "¡Exito!",
                                text: "Se editó correctamente",
                                icon: "success",
                            });
                            return;
                        })
                        .catch((res) => {
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Error!",
                                text: "No se editó correctamente",
                                icon: "error",
                            });
                            console.warn("Error:", res);
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadCas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/cas/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataCas = res.data;
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadMaestro() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/maestro/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.dataMaesto = res.data;
                            this.dataMaesto = res.data.filter(
                                (e) =>
                                    e.codMaestro == "ND001"
                            );
                        })
                        .catch((res) => {
                            console.log("Error:", res);
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        formatearFecha(fecha) {
            // Dividir la fecha en partes: año, mes y día
            const partes = fecha.split("-");
            // Crear una nueva fecha con el formato "mm-dd-yyyy"
            const nuevaFecha = new Date(`${partes[1]}/${partes[2]}/${partes[0]}`);
            // Obtener el mes, día y año de la nueva fecha
            const mes = nuevaFecha.getMonth() + 1;
            const dia = nuevaFecha.getDate();
            const año = nuevaFecha.getFullYear();
            // Formatear la fecha en el formato deseado
            return `${mes.toString().padStart(2, "0")}-${dia
                .toString()
                .padStart(2, "0")}-${año}`;
        },
        clearForm() {
            this.pacienteData = {
                tipo_doc: null,
                num_doc: null,
                nombres: null,
                ape_pat: null,
                ape_mat: null,
                fecha_nac: null,
                cas: null,
                estado: 1,
                sexo: null,
                cordePac: null,
                latitud: null,
                longitud: null,
                direccion: null,
                distrito: null,
                user_id: null,
                telefonoAlterno: null,
                telefono: null,
                ubigeo_id: null
            };
            this.date = null;
            this.cas = null;
            this.maestro = null;
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        }
    },
    mounted() { },
    computed: {
        computedDateFormatted1() {
            return this.formatDate(this.date1);
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        dataCasOptions() {
            // Formatear los elementos del objeto según lo requerido por v-select
            return this.dataCas.map((item) => ({
                text: item.descripCas,
                value: item.url,
            }));
        },
        itemClass() {
            return (item) => {
                if (item.cupos_disponible === 0) {
                    return ""; // Aplica la clase "bg-primary" para el color #007bff
                } else {
                    return "bg-primary-table primary--text"; // No se aplica ninguna clase
                }
            };
        },
        filteredData() {
            if (!this.searchNombre && !this.searchDocumento) {
                return this.dataPaciente;
            }
            let filtered = this.dataPaciente;
            if (this.searchNombre) {
                filtered = filtered.filter((item) => {
                    const nombreCompleto = `${item.nombres} ${item.ape_pat} ${item.ape_mat}`;
                    return nombreCompleto.toLowerCase().includes(this.searchNombre.toLowerCase());
                });
            }
            if (this.searchDocumento) {
                filtered = filtered.filter((item) =>
                    item.num_doc
                        .toLowerCase()
                        .includes(this.searchDocumento.toLowerCase())
                );
            }
            return filtered;
        },
    },
    created() {
    },
    components: {
    },
};
</script>